import { stringArrayToObject } from '../../utils/array';

/* ------------- Auth actions ------------- */
export const actions = stringArrayToObject(
  [
    'ADD_TOAST',
    'CLOSE_TOAST',
    'SET_TIMEOUT',
  ],
  '@@TOAST',
);

export const actionCreators = {
  addToast({ type, message, duration }) {
    return {
      type: actions.ADD_TOAST,
      payload: {
        type,
        message,
        duration: duration || 5300,
      },
    };
  },
  closeToast(id) {
    return {
      type: actions.CLOSE_TOAST,
      payload: {
        id,
      },
    };
  },
  setToastTimeout(id, timeout) {
    return {
      type: actions.SET_TIMEOUT,
      payload: { id, timeout },
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Toasts/actions.js